import React, { useCallback } from 'react'
import { ErrorMessage } from 'donate/shared/error_message'
import { FormValues } from 'donate/types'
import { IbanElement } from '@stripe/react-stripe-js'
import { IbanElementChangeHandler, IbanElementStripeProps } from '../types'
import { StripeElementStyle, StripeIbanElement } from '@stripe/stripe-js'
import { StripeSEPADebitFieldsComp } from './types'
import { connect } from 'formik'
import { useIsStripeLoaded } from '../../stripe_context'
import { useResetFieldOnMethodChange } from '../use_reset_field_on_method_change'

//TODO: Improve types
export const StripeSEPADebitFields: StripeSEPADebitFieldsComp = connect<{}, FormValues>(({ formik }) => {
  const handleChange: IbanElementChangeHandler = useCallback(
    (event) => {
      if (event.error) {
        formik.setFieldTouched('stripe_token', true, false)
        formik.setFieldError(
          'stripe_token',
          i18n.t(`donate.errors.stripe_sepa_debit_${event.error.code}`, {
            defaultValue: i18n.t('donate.errors.unknown_error'),
          })
        )
        formik.setSubmitting(false)
      } else {
        formik.setFieldTouched('stripe_token', true, false)
        formik.setFieldError('stripe_token', undefined)
      }
    },
    [formik]
  )
  const onReady = useResetFieldOnMethodChange<StripeIbanElement>(formik.values.payment_method)
  const isStripeLoaded = useIsStripeLoaded()
  const show = formik.values.payment_method === 'stripe_sepa_debit'
  if (!isStripeLoaded)
    return (
      <div className="donations-form-stripe-fields mb-6">
        <h4>{i18n.t('donate.sepa_fields.headline')}</h4>
        <p>{i18n.t('donate.errors.stripe_sepa_debit_unavailable')}</p>
      </div>
    )

  // beacuse of the new library's behaviour unmounting Stripe components will cause an exception,
  // unless it's removed together with it's provider
  return (
    <div style={{ display: show ? 'block' : 'none' }} className="donations-form-stripe-fields mb-6">
      <h4>
        <span>{i18n.t('donate.sepa_fields.headline')}</span>
        <span>*</span>
      </h4>
      <IbanElement onReady={onReady} onChange={handleChange} {...ibanElementProps} />
      <ErrorMessage field="stripe_token" />
    </div>
  )
})

StripeSEPADebitFields.displayName = 'StripeSEPADebitFields'

const style: StripeElementStyle = {
  base: {
    'color': '#32325d',
    'lineHeight': '18px',
    'fontFamily': '"Helvetica Neue", Helvetica, sans-serif',
    'fontSmoothing': 'antialiased',
    'fontSize': '16px',
    '::placeholder': {
      color: '#aab7c4',
    },
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a',
  },
}

const ibanElementProps: IbanElementStripeProps = {
  options: {
    supportedCountries: ['SEPA'],
    placeholderCountry: 'DE',
    style,
  },
}
